export const OpenItemPaymentTypes =  {
	CASH: "Bar",
	CASH_DEBITCARD: "Bar - EC",
	CASH_MASTERCARD: "Bar - Mastercard",
	CASH_VISA: "Bar - Visa",
	CREDITCARD: "Kreditkarte",
	SEPADEBIT: "Lastschrift",
	PAYPAL: "Paypal",
	PAYPAL_PLUS: "PayPal Plus",
	SOFORT: "Sofortüberweisung",
	BANKWIRE: "Überweisung",
	INVOICE: "Rechnung",
	REGISTRATION: 'Anmeldung',
	UNKNOWN: "nicht bekannt",
}

export class OpenItemPayment {
	info: string
	value: number
	paymentType: string
	createdAt: string
	username: string
	byLeomedia: boolean
}



// WEBPACK FOOTER //
// ./src/app/models/open-item-payment.model.ts